import { render } from "./OrderResult.vue?vue&type=template&id=a6539666&scoped=true&ts=true"
import script from "./OrderResult.vue?vue&type=script&lang=ts"
export * from "./OrderResult.vue?vue&type=script&lang=ts"

import "./OrderResult.vue?vue&type=style&index=0&id=a6539666&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6539666"]])

export default __exports__